export default "__VITE_ASSET__CnLzf$Gx__"